export enum StatusSaque {
  PENDING = 1,
  COMPLETED = 2,
  REFUSED = 3,
  ANALYSIS = 4,
  APPROVED = 5,
}

export const STATUS_SAQUE_LABEL: Record<StatusSaque, string> = {
  [StatusSaque.PENDING]: 'Pendente',
  [StatusSaque.COMPLETED]: 'Completo',
  [StatusSaque.REFUSED]: 'Recusado',
  [StatusSaque.ANALYSIS]: 'Em análise',
  [StatusSaque.APPROVED]: 'Aprovado',
};

export enum MoedaSaque {
  BRL = 1,
  USD = 2,
  EUR = 3,
  CLP = 4,
  PEN = 5,
  COP = 6,
  MXN = 7,
  CAD = 8,
  JPY = 9,
  GBP = 10,
  DKK = 11,
  NOK = 12,
  SEK = 13,
  PYG = 14,
}

export const MOEDA_SAQUE_LABEL: Record<MoedaSaque, string> = {
  [MoedaSaque.BRL]: 'BRL',
  [MoedaSaque.USD]: 'USD',
  [MoedaSaque.EUR]: 'EUR',
  [MoedaSaque.CLP]: 'CLP',
  [MoedaSaque.PEN]: 'PEN',
  [MoedaSaque.COP]: 'COP',
  [MoedaSaque.MXN]: 'MXN',
  [MoedaSaque.CAD]: 'CAD',
  [MoedaSaque.JPY]: 'JPY',
  [MoedaSaque.GBP]: 'GBP',
  [MoedaSaque.DKK]: 'DKK',
  [MoedaSaque.NOK]: 'NOK',
  [MoedaSaque.SEK]: 'SEK',
  [MoedaSaque.PYG]: 'PYG',
};

export const STATUS_DECIDIVEIS: StatusSaque[] = [
  StatusSaque.PENDING,
  StatusSaque.ANALYSIS,
];

export const isDecidivel = (status: StatusSaque) =>
  STATUS_DECIDIVEIS.includes(status);

export enum TipoContaSaque {
  CORRENTE = 1,
  POUPANCA = 2,
  SALARIO = 3,
}

export const TIPO_CONTA_LABEL: Record<TipoContaSaque, string> = {
  [TipoContaSaque.CORRENTE]: 'Corrente',
  [TipoContaSaque.POUPANCA]: 'Poupança',
  [TipoContaSaque.SALARIO]: 'Salário',
};

export enum TipoChavePixSaque {
  CPF = 1,
  CNPJ = 2,
  EMAIL = 3,
  TELEFONE = 4,
  ALEATORIA = 5,
}

export const TIPO_CHAVE_PIX_LABEL: Record<TipoChavePixSaque, string> = {
  [TipoChavePixSaque.CPF]: 'CPF',
  [TipoChavePixSaque.CNPJ]: 'CNPJ',
  [TipoChavePixSaque.EMAIL]: 'E-mail',
  [TipoChavePixSaque.TELEFONE]: 'Telefone',
  [TipoChavePixSaque.ALEATORIA]: 'Aleatória',
};

export interface SaqueClienteResumo {
  id: string;
  nome: string;
  sobrenome: string | null;
  email: string;
}

export interface SaqueContaResumo {
  id: string | null;
  resumo: string;
}

export interface SaqueListItem {
  id: string;
  cliente: SaqueClienteResumo;
  valor: number;
  valorLiquido: number;
  status: StatusSaque;
  statusDescricao: string;
  moeda: MoedaSaque;
  moedaSigla: string;
  moedaDestino: MoedaSaque;
  moedaDestinoSigla: string;
  createdAt: string;
  contaBancaria: SaqueContaResumo;
}

export interface PaginatedSaques {
  data: SaqueListItem[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface SaqueClienteDetail {
  id: string;
  nome: string;
  sobrenome: string | null;
  email: string;
  documento: string | null;
  tipoPessoa: string | null;
}

export interface SaqueContaDetail {
  id: string | null;
  moeda: MoedaSaque | null;
  moedaSigla: string | null;
  tipoConta: number | null;
  nome: string | null;
  pais: string | null;
  bancoNome: string | null;
  bancoCodigo: string | null;
  agencia: string | null;
  contaNumero: string | null;
  contaDigito: string | null;
  chavePix: string | null;
  tipoChavePix: number | null;
  nomeTitular: string | null;
  routingNumber: string | null;
  swiftCode: string | null;
  emailBeneficiario: string | null;
  endereco: {
    pais: string;
    codigoPostal: string;
    estado: string;
    cidade: string;
    complemento?: string;
  } | null;
}

export interface SaqueDetail {
  id: string;
  status: StatusSaque;
  statusDescricao: string;
  valor: number;
  taxa: number;
  valorLiquido: number;
  moeda: MoedaSaque;
  moedaSigla: string;
  moedaDestino: MoedaSaque;
  moedaDestinoSigla: string;
  tipo: number;
  observacoes: string | null;
  createdAt: string;
  updatedAt: string | null;
  completedAt: string | null;
  cliente: SaqueClienteDetail;
  contaBancaria: SaqueContaDetail;
}

export interface SaquesFilters {
  status?: StatusSaque | '';
  moeda?: MoedaSaque | '';
  clienteNome?: string;
  clienteEmail?: string;
  dataInicio?: string;
  dataFim?: string;
  valorMinimo?: number | '';
  valorMaximo?: number | '';
}

export type SaquesFiltersInput = Partial<SaquesFilters>;
